import React from 'react';
import BaseChart from './BaseChart';
import { ChartType } from './BaseChart';

interface PerformanceMetricsChartProps {
  data: {
    labels: string[];
    values: number[];
  };
  title?: string;
  type?: ChartType;
  options?: {
    scales?: {
      r?: {
        min?: number;
        max?: number;
        ticks?: {
          stepSize?: number;
        };
      };
    };
  };
}

const PerformanceMetricsChart: React.FC<PerformanceMetricsChartProps> = ({
  data,
  title = 'Performance Metrics',
  type = 'radar',
  options = {},
}) => {
  const chartData = {
    labels: data.labels,
    datasets: [
      {
        label: 'Performance',
        data: data.values,
        backgroundColor: 'rgba(54, 162, 235, 0.2)',
        borderColor: 'rgba(54, 162, 235, 1)',
        borderWidth: 2,
        pointBackgroundColor: 'rgba(54, 162, 235, 1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgba(54, 162, 235, 1)',
      },
    ],
  };

  const defaultOptions = {
    scales: {
      r: {
        min: 0,
        max: 100,
        ticks: {
          stepSize: 20,
        },
      },
    },
    plugins: {
      legend: {
        position: 'top' as const,
      },
      title: {
        display: true,
        text: title,
      },
    },
  };

  const mergedOptions = {
    ...defaultOptions,
    ...options,
  };

  return (
    <BaseChart
      type={type}
      data={chartData}
      title={title}
      height={400}
      width={400}
      options={mergedOptions}
    />
  );
};

export default PerformanceMetricsChart; 